<template>
  <div class="new-chip">
    <div
      v-for="tag in tagList"
      :key="tag"
      class="new-chip-item"
      :style="styles"
      text-color="#007bff"
      @click="isSinglePost(tag)"
    >
      {{ setValue(tag) }}
    </div>
  </div>
</template>

<script>
import { titleize } from '@/helper/index.js'
import { RegisterEvent } from '@/analytics'
import { convertEmToPixels } from '@/helper/helper'
import { _ } from 'vue-underscore'

export default {
  name: 'Links',
  props: {
    tagList: Array,
    isSingle: Boolean
  },
  data: () => ({
    titleizeWord: ''
  }),
  computed: {
    styles () {
      const result = convertEmToPixels(16)
      return {
        'font-size': result + 'px',
        'line-height': `${result + 2}px`
      }
    }
  },
  methods: {
    setValue: function (word) {
      if (!_.isEmpty(word)) return `#${titleize(word)}`
    },
    goToTag (tag) {
      RegisterEvent('tag_selected', { target_id: tag, target_type: 'tag_name' })
      return this.$router.push({
        name: 'MixedTag',
        params: { name: tag }
      })
    },
    isSinglePost (tag) {
      return !this.isSingle ? this.goToTag(tag) : null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/publication/tags.vue